<template>
  <div>
    <b-card :header="caption">
      <b-link :to="{name: 'welcome-category-create'}">
        <b-button variant="outline-primary" :style="{marginBottom: '18px'}" >
          创建分类
        </b-button>
      </b-link>
      <b-table show-empty responsive="sm" :busy="items === null" :items="items" :fields="fields" :current-page="currentPage" :emptyText="tableEmptyText">
        <template #cell(op)="data">
          <b-link :to="{name: 'welcome-category-update', params: {categoryCode: data.item.code}}">
            <b-button size="sm" variant="outline-warning">
              <i class="fa fa-edit" /> 编辑
            </b-button>
          </b-link>
          <b-button size="sm" variant="outline-danger" @click="deleteTip(data.index)">
            <i class="fa fa-trash-o" /> 删除
          </b-button>
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle" />
            <strong>加载中...</strong>
          </div>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        prev-text="<<"
        next-text=">>"
        @change="changePage"
        hide-goto-end-buttons
        first-number
        last-number
      />
    </b-card>
    <TipModal ref="tip" :tipData="tipData">
      <template v-slot:footer>
        <b-button size="sm" variant="outline-dark" @click="cancelDelete()" >取消</b-button>
        <b-button size="sm" variant="outline-danger" @click="deleteCategory()" >删除</b-button>
      </template>
    </TipModal>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'
import TipModal from '@/components/TipModal'

export default {
  name: 'welcome-category',
  components: {TipModal},
  mixins: [Error],
  props: {
    caption: {
      type: String,
      default: '功能分类'
    }
  },
  data () {
    return {
      items: null,
      fields: consts.WELCOME_CATEGORY_FIELDS,
      currentPage: 1,
      perPage: consts.DEFAULT_PER_PAGE,
      totalRows: 0,
      tableEmptyText: consts.TABLE_EMPTY_TEXT,
      tipData: null,
      firstSave: true
    }
  },
  created () {
    if (this.firstSave && this.$route.params.save) {
      this.totalRows = sessionStorage.getItem('wscRow')
      this.currentPage = sessionStorage.getItem('wscPage')
      this.firstSave = false
    }
    this.fetchData()
  },
  beforeDestroy () {
    sessionStorage.setItem('wscRow', this.totalRows)
    sessionStorage.setItem('wscPage', this.currentPage)
  },
  methods: {
    fetchData () {
      api.fetchListData(this, api.getWelcomeCategoryList(), 'categorys')
    },
    changePage (page) {
      this.currentPage = page
      this.fetchData()
    },
    deleteTip (idx) {
      this.tipData = {
        data: {cid: this.items[idx]._id},
        title: '警告',
        msg: '是否确定删除分类【' + this.items[idx].name + '】？',
        headerBgVariant: 'danger',
        headerTextVariant: 'light'
      }
      this.$refs.tip.modalShow()
    },
    deleteCategory () {
      api.deleteData(this, api.getWelcomeCategoryDelete(this.$refs.tip.modalData.data.cid), null, this.deleteCallback)
    },
    deleteCallback () {
      this.$refs.tip.modalHide()
      this.changePage(this.currentPage)
    },
    cancelDelete () {
      this.$refs.tip.modalHide()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Category.vue?30fdccec